import { type UnifiedCollectionFormat } from '@app/client';

export const daas = () => ({
    tokens: () => ({
        collection: (slug: string) => `/tokens/collection/${slug}`,
        details: (contract: string, token: string) => `/tokens/${contract}/${token}`,
        ownersNumber: (contract: string, token: string) => `/tokens/${contract}/${token}/number_of_owners`,
        history: (contract: string, token: string) => `/tokens/${contract}/${token}/history`,
        list: () => `/tokens/list`,
        activity: () => ({
            transactions: `/transaction_actions/activity`,
            listing: `/listings/activity`,
            sales: `/sales/activity`,
        }),
    }),
    chain: () => ({
        wallets: () => ({
            contents: () => `/wallets/contents`,
        }),
    }),
    marketplace: () => ({
        collections: () => ({
            byContract: () => `/collections/by_contract`,
            default: () => `/market_place_collections`,
            contracts: (slug: string) => `/collections/${slug}/contracts`,
            listings: (slug: string) => `/listings/collection/${slug}`,
            activity: (slug: string) => ({
                sales: `/sales/ownerActivity/${slug}`,
                listings: `/listings/ownerActivity/${slug}`,
                transactions: `/transaction_actions/ownerActivity/${slug}`,
            }),
        }),
        collectionsBySlug: (slug: string) => `/collections/${slug}`,
        collectionsByTokenId: (contract: string, token: string) => `/collections/${contract}/${token}`,
        floorPrice: (slug: string) => `/floorprice/${slug}`,
        listings: (contract: string, token: number) => `/listings/${contract}/${token}`,
        owners: (contract: string) => `/contracts/owners/${contract}`,
        sales: (collection: string, token: number) => `/marketplace/sales/${collection}/${token}`,
        floorPriceChanges: '/floorprice/price_changes',
    }),
    contracts: () => ({
        details: (contractAddress: string) => `/contracts/${contractAddress}`,
        isOwner: (slug: string, wallet: string) => `/wallets/contents/${slug}/${wallet}`,
    }),
    graphql: () => ({
        activity: () => ({
            collection: () => `/collection/activity`,
            collectionStats: () => `/collectionmarketplacestats`,
        }),
        collectionActiveListings: () => `/collection/listings`,
        collection: () => ({
            bySlug: (slug: string) => ({
                floorPrice: () => `/slug/${slug}/floor-price`,
            }),
            byContract: (contractAddress: string) => ({
                floorPrice: () => `/contract/${contractAddress}/floor-price`,
                listings: () => ({
                    byPriceRange: (minPriceWei: number, maxPriceWei: number) => ({
                        active: (limit: number) =>
                            `/contract/${contractAddress}/listings/${minPriceWei}/${maxPriceWei}/limit/${limit}`,
                        total: () => `/contract/${contractAddress}/listings/${minPriceWei}/${maxPriceWei}/total`,
                    }),
                }),
                sales: () => ({
                    byDate: (dateFrom: string) => ({
                        total: () => `/contract/${contractAddress}/sales/${dateFrom}`,
                    }),
                    byPriceRange: (minPriceWei: number, maxPriceWei: number) => ({
                        total: () => `/contract/${contractAddress}/sales/${minPriceWei}/${maxPriceWei}/total`,
                    }),
                    recentTierSales: (dateFrom: string, floorPriceWei: number) =>
                        `/contract/${contractAddress}/sales/${dateFrom}/${floorPriceWei}`,
                }),
            }),
        }),
    }),
    v2: {
        assets: {
            token: (token: string) => `https://daas.y.at/v2/metadata/image/token/${token}`,
            collections: (slug: string) => {
                if (!slug) return undefined;
                return `https://daas.y.at/v2/metadata/image/collection/${slug}`;
            },
        },
        collection: (collection: UnifiedCollectionFormat) => ({
            contents: {
                tokens: `/collection/contents/${collection}/tokens`,
                traits: `/collection/contents/${collection}/traits`,
            },
        }),
        market: {
            floorprice: `/market/floorprice/history`,
            listing: `/market/listing/active`,
            listingById: `/market/listing/by_id`,
        },
        metadata: {
            collection: `/metadata/collection`,
            contract: `/metadata/contract`,
            token: `/metadata/token`,
            tokenCount: `/metadata/collection/token_count`,
        },
        ownership: {
            token: `/ownership/token/count`,
            contract: `/ownership/contract/count`,
            collection: `/ownership/collection`,
        },
        stats: {
            collection: {
                salesVolume: `/stats/collection/sale_volume`,
            },
        },
    },
});
